import { differenceInDays } from 'date-fns'

import { noLocationRoute } from '../routes/routes'

function locationSearchWatcher(context, callback) {
  let { locationSearch } = context.props
  if (locationSearch.locations.foundLocations != null) {
    if (locationSearch.locations.foundLocations.length > 0) {
      context.setState({
        locationId: locationSearch.locations.foundLocations[0].id,
      })
      callback(locationSearch)
    } else if (context.state != null && context.state.loading != null && !context.state.loading) {
      context.invalidLocation()
    } else {
      window.location.href = noLocationRoute.path
    }
  }
}

export const safeDifferenceInDays = activationDate =>
  Math.max(differenceInDays(activationDate, new Date()), 0)

// Places the default location at the beginning of the list
export const formatSavedLocations = (savedLocations, defaultLocationId) => {
  if (savedLocations && defaultLocationId) {
    const defaultLocation = savedLocations?.find(
      savedLocation => savedLocation.deliveryLocationId === defaultLocationId,
    )
    if (defaultLocation) {
      savedLocations.splice(savedLocations.indexOf(defaultLocation), 1)
      savedLocations.unshift(defaultLocation)
    }

    return savedLocations
  }
}

export default locationSearchWatcher
